import { Button } from "@/components/ui/button";

const FooterCTA = () => (
  <footer>
    <div className="border-t border-border/50">
      <div className="container-wide py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
        <span>© 2026 AntAtlas, Inc. All rights reserved.</span>
        <div className="flex gap-6">
          <a href="/privacy" className="hover:text-foreground transition-colors">Privacy</a>
          <a href="/terms" className="hover:text-foreground transition-colors">Terms</a>
        </div>
      </div>
    </div>
  </footer>
);

export default FooterCTA;
